import { format, addHours } from 'date-fns'

interface addHoursDateProtocol {
  date?: Date
  amount?: number
}

interface formatDateProtocol {
  date?: Date
  pattern?: string
}

export const formatDate = ({
  date = new Date(),
  pattern = "yyyy-MM-dd'T'HH:mm",
}: formatDateProtocol): string => {
  return format(date, pattern)
}

export const addHoursDate = ({
  date = new Date(),
  amount = 0,
}: addHoursDateProtocol): Date => {
  return addHours(date, amount)
}
